// System Imports
import { BrowserModule } from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {IonicApp, IonicModule} from 'ionic-angular';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { IonicStorageModule } from "@ionic/storage";
import { Keychain } from "@awesome-cordova-plugins/keychain/ngx";

// App Specific Imports
import { MyApp } from './app.component';

// Other imports
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from "@angular/common/http";
import { ApiRestProvider } from '../providers/api-rest/api-rest';
import { ExamProvider } from '../providers/exam/exam';
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faEnvelope,
  faEdit,
  faCheckCircle as farCheckCircle, faClock
} from "@fortawesome/free-regular-svg-icons";
import {
  faExclamationTriangle,
  faCheckCircle,
  faWifi,
  faQuestionCircle,
  faBatteryFull,
  faBatteryHalf,
  faBatteryThreeQuarters,
  faBatteryQuarter,
  faFingerprint,
  faEllipsisH,
  faSpinner, faThumbsUp, faFileDownload
} from "@fortawesome/free-solid-svg-icons";

import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {OpenNativeSettings} from "@awesome-cordova-plugins/open-native-settings/ngx";
import { ApiBoxProvider } from '../providers/api-box/api-box';
import { AppStateProvider } from '../providers/app-state/app-state';
import {MomentModule} from "angular2-moment";
import {NgIdleKeepaliveModule} from "@ng-idle/keepalive";
import { AudioProvider } from '../providers/audio/audio';
import {NativeAudio} from "@awesome-cordova-plugins/native-audio/ngx";
import {Camera} from "@awesome-cordova-plugins/camera/ngx";
import {Ng5SliderModule} from 'ng5-slider';
import {FileOpener} from "@awesome-cordova-plugins/file-opener/ngx";
import {File} from "@awesome-cordova-plugins/file/ngx";
import {InAppBrowser} from "@awesome-cordova-plugins/in-app-browser/ngx";
import {Keyboard} from "@awesome-cordova-plugins/keyboard/ngx";
import { BleEmg } from '../instruments/BleEmg';
import { BleHrv } from '../instruments/BleHrv';
import { HelpProvider } from '../providers/help/help';
import {ProgressBarModule} from "angular-progress-bar";
import {RequestInterceptor} from "../providers/api-rest/interceptor";
import { LoadingProvider } from '../providers/loading/loading';
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import { ModalProvider } from '../providers/modal/modal';
import {AppVersion} from "@awesome-cordova-plugins/app-version/ngx";
import {DatePipe} from "@angular/common";
import {BLE} from "@awesome-cordova-plugins/ble/ngx";
import {SecurityStorageService} from "../providers/security-storage/security-storage-service";
import {BleThermal} from "../instruments/BleThermal";
import {LogService} from "../providers/logging/log.service";
import {LogPublishersService} from "../providers/logging/log-publishers.service";
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// Add icons to library
library.add(faEnvelope);
library.add(faEdit);
library.add(faExclamationTriangle);
library.add(faThumbsUp);
library.add(faCheckCircle);
library.add(faQuestionCircle);
library.add(faWifi);
library.add(faBatteryFull);
library.add(faBatteryHalf);
library.add(faBatteryThreeQuarters);
library.add(faBatteryQuarter);
library.add(faFingerprint);
library.add(faEllipsisH);
library.add(faSpinner);
library.add(farCheckCircle);
library.add(faClock);
library.add(faFileDownload);

@NgModule({
  declarations: [
    MyApp,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp, {
      statusbarPadding: true,
      tabsHideOnSubPages: true,
      mode: 'ios',
      backButtonText: '',
      preloadModules: true
    }),
    BrowserAnimationsModule,
    IonicStorageModule.forRoot(),
    MomentModule,
    NgIdleKeepaliveModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    StatusBar,
    SplashScreen,
    Keychain,
    OpenNativeSettings,
    NativeAudio,
    InAppBrowser,
    ApiRestProvider,
    ApiBoxProvider,
    LoadingProvider,
    ExamProvider,
    Camera,
    BLE,
    AppStateProvider,
    AudioProvider,
    Keyboard,
    Ng5SliderModule,
    ProgressBarModule,
    File,
    FileOpener,
    HelpProvider,
    BleEmg,
    BleHrv,
    BleThermal,
    [{ provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true}],
    LoadingProvider,
    ModalProvider,
    AppVersion,
    DatePipe,
    SecurityStorageService,
    LogService,
    LogPublishersService
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts